import useInputChange from "hooks/useInputChange";
import useServiceCategories from "hooks/userServiceCategories";
import { FormEvent, useEffect } from "react";
import { Skill, SkillCreate } from "types/general.interface";

interface Props {
  onSubmit: (record: SkillCreate) => void;
  data: Skill | null;
  isLoading?: boolean;
  onCancel: () => void;
}
export default function SkillForm({
  onSubmit,
  data,
  isLoading,
  onCancel,
}: Props) {
  const { state, onChange, setState } = useInputChange<SkillCreate>({
    serviceCategory: "",
    name: "",
  });

  const { data: categories } = useServiceCategories();

  useEffect(() => {
    if (data) {
      setState(data);
    }
  }, [data]);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    onSubmit(state);
  };

  return (
    <form action="#!" onSubmit={handleSubmit}>
      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">Name</label>
        <input
          type="text"
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder="Cooking, Care giving etc"
          name="name"
          onChange={onChange}
          value={state.name}
        />
      </div>
      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          Service Category
        </label>
        <select
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          name="serviceCategory"
          onChange={onChange}
          value={state.serviceCategory}
          required
        >
          <option value="">Select Service Category</option>
          {categories?.data?.map((category) => (
            <option key={category._id} value={category.name}>
              {category.name}
            </option>
          ))}
        </select>
      </div>

      <div className="flex justify-end gap-2 mt-4">
        <button
          type="reset"
          data-modal-close="addDocuments"
          className="px-4 py-2 text-sm rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 text-sm rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:opacity-60 transition-colors"
        >
          {isLoading ? "Loading..." : "Submit"}
        </button>
      </div>
    </form>
  );
}
